import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview-dialog',
  template: `
    <div class="image-preview-dialog-container">
      <div class="image-preview-header">
        <h2>{{ data.imageName }}</h2>
        <button (click)="close()" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="image-preview-content">
        <img [src]="data.imageUrl" [alt]="data.imageName" />
      </div>
    </div>
  `,
  styles: [
    `
      .image-preview-dialog-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #000;
        color: white;
      }

      .image-preview-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        background-color: rgba(0, 0, 0, 0.8);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .image-preview-header h2 {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
      }

      .image-preview-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
        padding: 16px;
      }

      .image-preview-content img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    `
  ],
  standalone: false
})
export class ImagePreviewDialogComponent {
  dialogRef = inject<MatDialogRef<ImagePreviewDialogComponent>>(MatDialogRef);
  data = inject<{
    imageUrl: string;
    imageName: string;
  }>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
